module.exports = __webpack_public_path__ + "img/logo_bidipay.882d2606.png";